import { Directive, Input } from '@angular/core';
import { AccessService } from './access.service';

@Directive({
    selector: '[giq-access]',
    standalone: false
})
export class AccessDirective {
  @Input('giq-access') access: string | null = null;
  @Input('giq-access-type') type: string | null = 'app';

  constructor(private accessService: AccessService) {}

  ngOnInit() {
    if (this.access) {
      this.accessService.access(this.access, this.type || 'app');
    }
  }
}
